<template>
    <form id="upload">
        <h3>Upload</h3>
        <label for="name">Name</label>
        <input
            type="text"
            ref="name"
            required
            minlength="5"
            maxlength="40"
            @keyup="
                () => {
                    checkValid(true);
                }
            "
        />
        <label for="description">Description</label>
        <input
            type="text"
            ref="description"
            required
            minlength="10"
            maxlength="255"
            @keyup="
                () => {
                    checkValid(false, true);
                }
            "
        />
        <label for="map" class="file">Map</label>
        <input
            type="file"
            id="map"
            ref="map"
            @change="
                () => {
                    checkValid(false, false, true);
                }
            "
            accept="application/JSON"
            required
        />
        <label for="picture" class="file">Picture</label>
        <input
            type="file"
            id="picture"
            ref="picture"
            @change="
                (e) => {
                    checkValid(false, false, false, true);
                    readURL(e.target);
                }
            "
            accept="image/png"
            required
        />
        <img src="" ref="preview" />
        <button
            type="button"
            @click="
                () => {
                    if (checkValid(true, true, true, true)) sendPost();
                }
            "
            class="upload button-green"
        >
            Upload
        </button>
    </form>
</template>

<script>
import variables from "../../api/variables.json";
export default {
    name: "Upload",
    data() {
        return {};
    },
    computed: {
        token() {
            return this.$store.getters.token;
        },
    },
    updated() {},
    mounted() {},
    methods: {
        readURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = (e) => {
                    const preview = this.$refs["preview"];
                    preview.setAttribute("src", e.target.result);
                };

                reader.readAsDataURL(input.files[0]);
            }
        },
        readJSON(input) {
            return new Promise((resolve, reject) => {
                if (input.files && input.files[0]) {
                    var reader = new FileReader();

                    reader.onload = function(e) {
                        if (e.target.result)
                            resolve(JSON.parse(e.target.result));
                        else reject(null);
                    };

                    reader.readAsText(input.files[0]);
                }
            });
        },

        updateLabel(input, value = undefined) {
            const labels = document.getElementsByClassName("file");
            let label = null;
            for (let i = 0; i < labels.length; i++) {
                const currentLabel = labels[i];
                if (currentLabel.getAttribute("for") === input.id)
                    label = currentLabel;
            }
            if (!label) return;
            if (typeof value === "undefined") {
                if (input.files.length > 0) {
                    label.setAttribute("data-value", "true");
                } else {
                    label.setAttribute("data-value", "false");
                }
            } else {
                label.setAttribute("data-value", value);
            }
        },
        checkValid(
            name = false,
            description = false,
            map = false,
            picture = false
        ) {
            let valid = true;
            if (name) {
                if (this.$refs["name"].checkValidity()) {
                    this.$refs["name"].setAttribute("data-value", "true");
                } else {
                    this.$refs["name"].setAttribute("data-value", "false");
                    valid = false;
                }
            }
            if (description) {
                if (this.$refs["description"].checkValidity()) {
                    this.$refs["description"].setAttribute(
                        "data-value",
                        "true"
                    );
                } else {
                    this.$refs["description"].setAttribute(
                        "data-value",
                        "false"
                    );
                    valid = false;
                }
            }
            //TODO: check map validity
            if (map) {
                if (
                    this.$refs["map"].files.length !== 1 ||
                    this.$refs["map"].files[0].type !== "application/json"
                ) {
                    valid = false;
                    this.updateLabel(this.$refs["map"], false);
                } else {
                    this.updateLabel(this.$refs["map"]);
                }
            }
            if (picture) {
                this.updateLabel(this.$refs["picture"]);
                if (
                    this.$refs["picture"].files.length !== 1 ||
                    this.$refs["picture"].files[0].type !== "image/png"
                ) {
                    valid = false;
                    this.updateLabel(this.$refs["picture"], false);
                } else {
                    this.updateLabel(this.$refs["picture"]);
                }
            }

            return valid;
        },

        async sendPost() {
            fetch(`${variables.host}/api/map`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${this.token}`,
                },
                body: JSON.stringify({
                    picture: this.$refs["preview"].getAttribute("src"),
                    name: this.$refs["name"].value,
                    description: this.$refs["description"].value,
                    map: await this.readJSON(this.$refs["map"]),
                }),
            })
                .then((response) => {
                    if (response.status === 200) {
                        window.location.href = "/";
                    } else {
                        if (response.status === 401) {
                            this.$store.commit("setAuthentication", {
                                token: null,
                                userId: null,
                            });
                            this.$router.push({ name: "login" });
                        }
                        if (response.status === 429) {
                            response.json().then(({ time }) => {
                                alert(
                                    "You can only upload a map every 10 minutes. There are " +
                                        Math.floor(time / 60) +
                                        " minutes remaining."
                                );
                            });
                        }
                        this.checkValid(true, true, true, true);
                    }
                })
                .catch(() => {
                    this.checkValid(true, true, true, true);
                });
        },
    },
};
</script>
<style scoped lang="scss" src="./assets/css/upload.scss"></style>
